import React from 'react';
import ReactDOM from 'react-dom';
import { ALCHEMISTEN } from 'da-three';
import Overlay from './ui/overlay.js';

export default class Interface{
    constructor(studio){
        this.studio = studio;
        this.i18n = ALCHEMISTEN.instance.i18n;
        this.auth = ALCHEMISTEN.instance.auth;
        this.timerID = -1;
        //this.studio.addEventListener('objectProgress',this.updateLoadingScreen.bind(this));
        this.studio.dispatcher.addEventListener('animationState',this.onAnimationRunning.bind(this));
        this.studio.dispatcher.addEventListener('objectComplete',this.onObjectComplete.bind(this));
        this.studio.dispatcher.addEventListener('highlightClicked',this.onHighlightClicked.bind(this));
        this.studio.dispatcher.addEventListener('navigateStart', this.onNavigateStart.bind(this));
        this.studio.dispatcher.addEventListener('toggleState', this.onToggleState.bind(this));
        
        // get highlight manager and attach state listener
        const hlmngr = this.studio.getManagerByName("Highlights");
        hlmngr.dispatcher.addEventListener("onstate", this.onHighlightState.bind(this));
        hlmngr.dispatcher.addEventListener("visibilityChange", this.onHighlightVisibility.bind(this));
        hlmngr.dispatcher.addEventListener("animationDelay", this.onAnimationDelay.bind(this));

        this.highlightManager = hlmngr;

        this.features = {
            animations: this.studio.config.features.useAnimations.active,
            animationNames: [],
            changeMaterials: this.studio.config.object.changeMaterials,
            floaty: this.studio.config.features.useFloatingLight.active,
            fullscreen: false, //this.studio.config.features.useFullscreen.active,
            help: false,
            highlights: this.studio.config.highlights.filter(h => !h.isTrigger),
            highlightsAvailable: this.studio.config.features.showHighlight.active,
            hideTimelineAfterFirstPlay: this.studio.config.features.hideTimelineAfterFirstPlay,
            info: false,
            introText: this.studio.config.project.introText,
            languages: this.studio.config.project.languages,
            lightSetups: this.studio.lightMan.lightSetups,
            postprocessing: this.studio.config.features.usePostProcessing.active,
            ppBloom: this.studio.config.postprocess.bloom !== undefined,
            ppDof: this.studio.config.postprocess.dof !== undefined,
            ppEdgeglow: this.studio.config.postprocess.edgeglow !== undefined,
            ppFxaa: this.studio.config.postprocess.fxaa !== undefined,
            ppSsao: this.studio.config.postprocess.ssao !== undefined,
            ppTaa: this.studio.config.postprocess.taa !== undefined,
            settings: this.studio.config.features.useSettings.active,
            transparency: this.studio.config.features.useTransparency.active,
            wireframe: this.studio.config.features.useWireframe.active
        };

        console.log("Studio", this.studio);

        this.state = {
            activeAnimation: "",
            activeHighlight: (this.features.highlights.length > 0)?0:-1,
            activeLanguage: this.i18n.getLanguage(),
            activeLight: this.studio.activeLightSetup,
            activeColors: {},
            activeMaterial: this.features.changeMaterials.length>0?this.features.changeMaterials[0]:{},
            animationLength: 0.000,
            animationPlaying: this.studio.config.features.useAnimations.default,
            animationTime: 0.000,
            autopilot: false,
            boxAnimations: false,
            boxColors: false,
            boxLanguages: false,
            boxLights: false,
            boxSettings: false,
            animatedHighlights: true, // TEMP changes
            floaty: this.studio.flyingLightOn,
            fullscreen: false,
            help: false,
            highlights: (this.features.highlights.length <= 0)?false:this.studio.highlightsOn,
            highlightDetail: false,
            highlightList: false,
            highlightDelay: null,
            loadingProgress: 0,
            loggedIn: this.auth.loggedIn,
            objectID: -1,
            postprocessing: this.studio.config.features.usePostProcessing.default,
            ppBloom: this.studio.config.postprocess.bloom !== undefined,
            ppDof: this.studio.config.postprocess.dof !== undefined,
            ppEdgeglow: this.studio.config.postprocess.edgeglow !== undefined,
            ppFxaa: this.studio.config.postprocess.fxaa !== undefined,
            ppSsao: this.studio.config.postprocess.ssao !== undefined,
            ppTaa: this.studio.config.postprocess.taa !== undefined,
            rotate: this.studio.config.features.useAutoRotate.default,
            showLanguage: this.studio.config.showLanguage,
            showInfo: false,
            showIntro: this.studio.config.project.introText===''?false:true,
            subMenus: {
                postprocessing: false
            },
            timelineVisible: this.features.animations?true:false,
            wireframe: this.studio.config.features.useWireframe.default
        };
        
        let mLength = this.features.changeMaterials.length;
        for (let i=0;i<mLength;i++){
            this.state.activeColors[this.features.changeMaterials[i].name] = this.features.changeMaterials[i].defaultColor;
        }
        
        this.functions = {
            aniHandleChange: this.aniHandleChange.bind(this),
            changeMaterialColor: this.changeMaterialColor.bind(this),
            hoverHighlight: this.hoverHighlight.bind(this),
            setActiveAnimation: this.setActiveAnimation.bind(this),
            setActiveHighlight: this.setActiveHighlight.bind(this),
            setActiveLanguage: this.setActiveLanguage.bind(this),
            setActiveLightSetup: this.setActiveLightSetup.bind(this),
            toggle: this.toggle.bind(this),
            toggleSubMenu: this.toggleSubMenu.bind(this),
            translate: this.translate.bind(this),
            logout: this.logout.bind(this),
            resetAnimation: this.resetAnimation.bind(this)
        };
        
        //Deactivate functions if background transparency is used 
        this.toggleTransparency(false);
        this.updateWindowTitle();
        ReactDOM.render(
            <Overlay updateState={(updateState) => {
                    this.setState = updateState;
                }} 
                state={this.state} 
                features={this.features} 
                functions={this.functions} 
            />,
            document.getElementById('overlay')
        );
    }
    
    
    
    aniHandleChange(value) {
        this.studio.setAnimationTime(value);
        this.state = Object.assign({},this.state,{
            animationTime: value
        });
        if(this.setState !== undefined) {
            this.setState(this.state);
        }
    }
       
    
    
    changeMaterialColor(color,materialName){
        this.studio.changeMaterialColor(color.color,materialName);
        let colors = this.state.activeColors;
        colors[materialName] = color.name;
        this.state = Object.assign({},this.state,{activeColors: colors});
        if(this.setState !== undefined) {
            this.setState(this.state);
        }
    }
    
    
    
    closeBoxes(){
        let boxes = [
            'boxAnimations',
            'boxColors',
            'boxLanguages',
            'boxLights',
            'boxSettings',
            'highlightDetail',
            'highlightList',
            'showInfo',
            'showIntro'
        ];
        let bLength = boxes.length;
        for (let i=0;i<bLength;i++){
            if(this.state[boxes[i]]){
                this.toggle(boxes[i]);
            }
        }
    }
        
    
    
    hoverHighlight(index,active){
        if (index < 0){
            index = this.features.highlights.length-1;
        }
        if (index > this.features.highlights.length-1){
            index = 0;
        }
        this.studio.hoverHighlight(this.features.highlights[index].id,active);
    }

    logout() {
        this.auth.logout();
        this.state.loggedIn = this.auth.loggedIn;
        this.setState(this.state);
    }
    
    onAnimationRunning(event, action) {
        const overWrites = {};
        if (this.state.animationTime > action.time && // reverse time
            this.state.animationPlaying && // animation is playing
            (this.state.animationTime - action.time) > (action.duration * 0.8) // old time in right half, new time in left half
        ) {
            // check if timeline has to be hidden on animation end
            const hide = this.features.hideTimelineAfterFirstPlay;
            if (hide && hide.default) {
                setTimeout(() => { 
                    this.highlightManager.inDelay = false;
                    this.highlightManager.setTriggerVisibility(false);
                    this.studio.toggleAnimation(false);
                    this.studio.setAnimationTime(0);
                }, 1);
                overWrites.timelineVisible = false;
            }
        }
        if (this.setState !== undefined) {
            if (action.duration === 0) {
                console.log("ANim Dur ", action);
            }

            this.state = Object.assign({}, this.state, {
                animationTime: action.time,
                animationLength: action.duration,
                animationPlaying: action.playing,
                highlightList: false
            }, overWrites);

            this.setState(this.state);
        }
    } 
    
    onHighlightVisibility(event, visibleHighlights) {
        const highlights = this.studio.config.highlights.filter(h => !h.isTrigger && (visibleHighlights[h.id] || this.state.timelineVisible === false))
        this.features.highlights = highlights;
        this.state = Object.assign({}, this.state, {
            highlights: (this.features.highlights.length <= 0) ? false : this.studio.highlightsOn,
            highlightDetail: false,
            activeHighlight: 0
        });
        this.setState(this.state);
    }
    
    onHighlightClicked(event, { hl:highlight }){
        let hLength = this.features.highlights.length;
        for (let i=0;i<hLength;i++){
            if (this.features.highlights[i].id === highlight.id){
                this.setActiveHighlight(i, false, false);
                break;
            }
        }
    }

    resetAnimation() {
        this.state.timelineVisible = true;
        this.setState(this.state);
        setTimeout(() => { 
            this.studio.toggleAnimation(false);
            this.studio.setAnimationTime(0, true);
            this.highlightManager.setTriggerVisibility(true);
        }, 0);
    }
    
    onAnimationDelay(event, data) {
        this.state.highlightDelay = data;
        this.setState(this.state);
    }
    
    onHighlightState(event, state) {
        // 3 -> to_orbit
        // TODO refactor enumeration
        if (state === 3 && this.state.autopilot === true) {
            // disable autopilot in this case
            // TODO this is bullshit, we need to refactor this, i am not able to pass the value i want!
            // this.toggleAutopilot(false) does not trigger State change! -> inconsistent
            this.toggle("autopilot");
        }
    }
        
    
    
    onNavigateStart(){
        this.closeBoxes();
        let overlay = document.getElementById('overlay');
        overlay.className += ' hidden';
    }
    
    
    
    onObjectComplete(event,object){
        if (this.studio.config.features.useAnimations.active){
            let animations = this.studio.getAnimationNames(object.id);
            if (animations !== false) {
                this.studio.selectAnimation(object.id,animations[0]);
                this.features.animationNames = animations;
                this.state = Object.assign({},this.state,{
                    activeAnimation: animations.length > 0 ? this.features.animationNames[0] : "",
                });
                if(this.setState !== undefined) {
                    this.setState(this.state);
                }
            }
            if (this.studio.config.features.useAnimations.default){
                this.studio.toggleAnimation(true);
            }
        }
        
        
        this.state = Object.assign({},this.state,{
            loadingProgress: 100,
            objectID: object.id
        });
        if(this.setState !== undefined) {
            this.setState(this.state);
        }
        
        let root = document.getElementById('root');
        root.addEventListener('mousedown',this.closeBoxes.bind(this));
        root.addEventListener('touchstart',this.closeBoxes.bind(this));
    }
    
    
    
    setActiveAnimation(name){
        if (this.studio.selectAnimation(this.state.objectID,name)){
            this.state = Object.assign({},this.state,{
                activeAnimation: name
            });
            if(this.setState !== undefined) {
                this.setState(this.state);
            }
        }
    }
    
    
    
    setActiveHighlight(index, immediate = false, bubble = true) {
        console.log("set highlight", index, { immediate, bubble })
        let fromStart = false;
        if (index < 0){
            index = this.features.highlights.length-1;
        }
        if (index > this.features.highlights.length-1){
            index = 0;
            immediate = true;
            fromStart = true;
        }
        if (!this.state.highlightDetail){
            //this.toggle('highlightDetail');
        }
        if (bubble) {
            this.studio.triggerHighlight(this.features.highlights[index].id, immediate, fromStart);
        }
        
        this.state = Object.assign({}, this.state, { activeHighlight: index, highlightDetail: true});
        if (this.setState !== undefined) {
            this.state.highlightList = false;
            this.setState(this.state);
        }
    }
    
    
    
    setActiveLanguage(language){
        this.i18n.setLanguage(language);
        this.state = Object.assign({},this.state,{
            activeLanguage: language
        });
        if(this.setState !== undefined) {
            this.setState(this.state);
        }

        this.updateWindowTitle();
    }
    
    updateWindowTitle() {
        if (document) {
            const title = document.getElementsByTagName("title")[0];
            title.innerText = this.translate(this.studio.config.project.name).replace(/<[^>]+>/g, "");
        }
    }
    
    setActiveLightSetup(setup){
        this.studio.switchLightSetupTo(setup);
        this.state = Object.assign({},this.state,{activeLight:setup});
        if(this.setState !== undefined) {
            this.setState(this.state);
        }
    }
    
    
    
    setAutoplayTimeout(delay){
        this.timerID = window.setTimeout(()=>{
            let nextHLIndex = this.state.activeHighlight+1;
            if (nextHLIndex >= this.features.highlights.length){
                nextHLIndex = 0;
            }                
            this.setActiveHighlight(nextHLIndex);
            this.setAutoplayTimeout(this.features.highlights[nextHLIndex].delay);
        },delay);
    }
    
    onToggleState(event, {key, value}) {
        let current = this.state[key];
        if (current !== value) {
            this.toggle(key);
        }
    }
    
    toggle(target) {
        let newValue = !(this.state[target] === true);
        switch(target){
            case 'animationPlaying':
                this.studio.toggleAnimation(newValue);
                break;
            case 'autopilot':
                this.toggleAutopilot(newValue);
                break;
            case 'boxAnimations':
                if (newValue){
                    this.closeBoxes();
                }
                break;
            case 'boxColors':
                if (newValue){
                    this.closeBoxes();
                }
                break;
            case 'boxLanguages':
                if (newValue){
                    this.closeBoxes();
                }
                break;
            case 'boxLights':
                if (newValue){
                    this.closeBoxes();
                }
                break;
            case 'boxSettings':
                if (newValue){
                    this.closeBoxes();
                }
                break;
            case 'floaty':
                this.studio.toggleFlyingLight();
                break;
            case 'fullscreen':
                this.toggleFullscreen(newValue);
                break;
            case 'help':
                //Nothing to do here
                break;
            case 'highlights':
                this.studio.toggleClickzones(newValue);
                break;
            case 'highlightDetail':
                //Nothing to do here
                break;
            case 'highlightList':
                if (newValue){
                    this.closeBoxes();
                }
                break;
            case 'postprocessing':
                this.studio.setPostprocessingOn(newValue);
                break;
            case 'ppBloom':
                this.studio.togglePostprocess('bloom');
                break;
            case 'ppDof':
                this.studio.togglePostprocess('dof');
                break;
            case 'ppEdgeglow':
                this.studio.togglePostprocess('edgeglow');
                break;
            case 'ppFxaa':
                this.studio.togglePostprocess('fxaa');
                break;
            case 'ppSsao':
                this.studio.togglePostprocess('ssao');
                break;
            case 'ppTaa':
                this.studio.togglePostprocess('taa');
                break;
            case 'rotate':
                this.studio.controls.autoRotate = newValue;
                break;
            case 'showInfo':
                if (newValue){
                    this.closeBoxes();
                }
                break;
            case 'showIntro':
                //Nothing to do here
                break;
            case 'wireframe':
                this.studio.setWireframeEnabled(newValue);
                break;
            case 'animatedHighlights':
                this.studio.setHighlightAnimations(newValue);
                break;
            default:
                target = null;
                break;
        }
        if (target !== null){
            let replace = {};
            replace[target] = newValue;
            this.state = Object.assign({},this.state,replace);
            if(this.setState !== undefined) {
                this.setState(this.state);
            }
        }
    }
    
    
    
    toggleAutopilot(active){
        if (active){
            this.setActiveHighlight(this.state.activeHighlight);
            this.setAutoplayTimeout(this.features.highlights[this.state.activeHighlight].delay);
        } else if (this.timerID > -1) {
            window.clearTimeout(this.timerID);
        }
    }
    
    
    
    toggleFullscreen(active){
        if (active){
            var elem = document.getElementById("fullscreen");
            if (elem.requestFullscreen) {
              elem.requestFullscreen();
            }else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen(elem.ALLOW_KEYBOARD_INPUT);
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            }
        }else{
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
        this.toggleTransparency(active);
    }
    
    
    
    toggleSubMenu(target){
        let subMenus = Object.assign({},this.state.subMenus);
    
        if (subMenus[target] !== undefined){
            subMenus[target] = !(subMenus[target] === true);
            this.state = Object.assign({},this.state,{subMenus:subMenus});
            if(this.setState !== undefined) {
                this.setState(this.state);
            }
        }
    }
    
    
    
    toggleTransparency(active){
        if (this.studio.config.features.useTransparency.active){
            if (active){
                this.studio.toggleSkyBox(active);
                this.features.postprocessing = this.studio.config.features.usePostProcessing.active;
                if (this.features.postprocessing && this.state.postprocessing !== this.studio.config.features.usePostProcessing.default){
                    this.toggle('postprocessing');
                }
                if (this.studio.config.surrounding.background !== '') {
                    document.getElementById('fullscreen').style.backgroundImage = 'url("'+this.studio.config.project.basedir+this.studio.config.surrounding.background+'")';
                } else {
                    document.getElementById('fullscreen').style.backgroundImage = 'url("'+this.studio.config.project.basedir+this.studio.config.project.static+"img/bg_scene_default.jpg')";
                }
            } else {
                this.studio.toggleSkyBox(false);
                if (this.state.postprocessing){
                    this.toggle('postprocessing');
                }
                this.features.postprocessing = false;
                document.getElementById('fullscreen').style.backgroundImage = 'none';
            }
        }
    }
    
    
    
    translate(key){
        return this.i18n.translate(key,this.studio.config.project.projectID);
    }
    
    
    
    updateLoadingScreen(event, status){
        let total = status.total;
        let loaded = status.loaded;
        let progress = (loaded / total)*100;
        
        if (!event.lengthComputable){
            progress = 1;
        }
        this.state = Object.assign({},this.state,{loadingProgress: progress});
        if(this.setState !== undefined) {
            this.setState(this.state);
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/studio/Interface.js